import StyleSheet from 'react-native-extended-stylesheet';

export const styles = StyleSheet.create({
  overlay: {
    backgroundColor: '$colorBgBase',
  },
});
